module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[70]557.f704eab.woff2";